import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  Xota2OperationProcessId,
  Xota2OperationProcessItem,
  Xota2UpdateProgress,
} from '@vi-iot/client/index';

@Component({
  selector: 'app-firmware-update-operation-status',
  templateUrl: './firmware-update-operation-status.component.html',
  styleUrls: ['./firmware-update-operation-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareUpdateOperationStatusComponent implements OnChanges {
  @Input() operation: Xota2OperationProcessItem;

  protected readonly Xota2OperationProcessId = Xota2OperationProcessId;
  protected readonly Xota2UpdateProgress = Xota2UpdateProgress;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.operation) {
      this.operation = changes.operation.currentValue;
    }
  }
}
